import request from './request'

// 获取banner广告
export function getBannerList() {
  const url = '/banner/home'
  return request.get(url)
}

// 获取精品课程数据
export function getJpkc() {
  const url = '/course/gettopcourse'
  return request.get(url, {
    params: {
      pagesize: 5
    }
  })
}

// 获取限时免费列表数据
export function getXsmf() {
  const url = '/course/getFreePromotionCourse'
  return request.get(url)
}

// 获取推荐大咖数据
export function getTjdk() {
  const url = '/teacher/top'
  return request.get(url)
}

// 获取最新微课数据
export function getZxwk() {
  const url = '/course/getmicrocourse'
  return request.get(url)
}

// 获取最新体系课数据
export function getZxtxk() {
  const url = '/course/getsystemcourse'
  return request.get(url)
}

// 全局搜索
export function searchAll(keyword) {
  const url = '/search'
  return request.get(url, {
    params: {
      keywords: keyword
    }
  })
}

// 公开课
// 获取限时免费列表数据
export function getGkk() {
  const url = '/course/getpubliccourse'
  return request.get(url)
}

// 获取限时免费列表数据
export function getHotSearch() {
  const url = '/search/log'
  return request.get(url)
}

// 猜你喜欢
export function getYouPrefer() {
  const url = '/course/rec_course'
  return request.get(url)
}

// 今日推荐
export function getTodayPush() {
  const url = '/course/todayRecommend'
  return request.get(url, {
    params: {
      type: 1
    }
  })
}

// 栏目推荐
export function getTodayColumn() {
  const url = '/course/todayRecommend'
  return request.get(url, {
    params: {
      type: 2
    }
  })
}

// 本周新课排行
export function getWeekNewest(page) {
  const url = '/course/week_hot'
  return request.get(url, {
    params: {
      page: page,
      pagesize: 10
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/index.js